var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ei-num-list"},_vm._l((_vm.numList),function(item,index){return _c('ei-num',{key:index,attrs:{"end":+item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }